class ButtonGroup extends HTMLElement {
    constructor() {
        super();
        this.selected = null;
        this.underline = null;
    }

    connectedCallback() {
        this.buttons = this.querySelectorAll("button");
        this.underline = this.querySelector(".underline");
        if (!this.underline) {
            this.underline = document.createElement("span");
            this.underline.classList.add("underline");
            this.appendChild(this.underline);
        }
        const selected = this.querySelector(".selected");
        if (selected) {
            this.selected = selected;
        } else if (this.buttons.length > 0 ) {
            this.selected = this.buttons[0];
        }
        this._updateSelection(false);
        this.buttons.forEach((button) => {
            button.addEventListener("click", this._handleClick.bind(this));
        });
    }

    _handleClick(event) {
        this.selected = event.target;
        this._updateSelection(true);
    }

    select(index, emitEvent = true) {
        this.selected = this.buttons[index];
        this._updateSelection(emitEvent);
    }

    _updateSelection(emitEvent) {
        this.buttons.forEach((button) => {
            button.classList.toggle("selected", button === this.selected);
        });
        const rect = this.selected.getBoundingClientRect();
        const parentRect = this.getBoundingClientRect();
        this.underline.style.width = `${rect.width}px`;
        this.underline.style.left = `${rect.left - parentRect.left - 1}px`;
        const selectedIndex = Array.from(this.buttons).indexOf(this.selected);
        if (emitEvent) {
            this.dispatchEvent(new CustomEvent('amb-button-group:changed', { bubbles: true,
                detail: { selected: this.selected, selectedIndex: selectedIndex} }));
            
        }
    }
}

if (!customElements.get("button-group")) {
    customElements.define("button-group", ButtonGroup);
}

